//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const switch1 = ref(1)
    const switch2 = ref('show')

    return { switch1, switch2 }
  },
}
